import times from 'lodash/times';

import { OptionType } from '@components/Select';

import { TimeData } from '../../types';

const defaultHourOptions: OptionType<number>[] = times(23, index => ({
    value: index,
    label: `${index}`,
}));

const defaultMinutesOptions: OptionType<number>[] = times(6, index => ({
    value: index * 10,
    label: `${index * 10}`,
}));

export function makeHourOptions(
    hourOptions: OptionType<number>[] | undefined,
    minTime?: TimeData,
    maxTime?: TimeData,
): OptionType<number>[] {
    let options = hourOptions ?? defaultHourOptions;

    if (minTime) {
        const minHourIndex = options.findIndex(({ value }) => value >= minTime.hour);
        if (minHourIndex > 0) {
            options = options.slice(minHourIndex);
        }
    }

    if (maxTime) {
        const maxHourIndex = options.findIndex(({ value }) => value >= maxTime.hour);
        if (maxHourIndex > 0) {
            options = options.slice(0, maxHourIndex + 1);
        }
    }

    return options;
}

export function makeMinutesOptions(
    time: TimeData,
    minutesOptions: OptionType<number>[] | undefined,
    minTime?: TimeData,
    maxTime?: TimeData,
): OptionType<number>[] {
    let options = minutesOptions ?? defaultMinutesOptions;

    if (minTime && time?.hour === minTime.hour) {
        const minIndex = options.findIndex(({ value }) => value >= minTime.minutes);
        if (minIndex > 0) {
            options = options.slice(minIndex);
        }
    }
    if (maxTime && time?.hour === maxTime.hour) {
        const maxIndex = options.findIndex(({ value }) => value >= maxTime.minutes);
        if (maxIndex > 0) {
            options = options.slice(0, maxIndex + 1);
        }
    }

    return options;
}
